export default __webpack_public_path__ + "static/media/document-front.e3d878af.svg";